import {
    windowWidth,
    mobileMatch,
    smoothScrollToTarget,
    notUndefined,
    getChildNumber
} from '../common';
import Promise from 'promise-polyfill';

let tags = [],
    cats = [],
    photos = [],
    courses = [];

const URL = "/magic_wall/";

export default class MagicWall {
    constructor() {
        if (document.querySelector('.js-photos-grid')) {

            this.init();

            $(document)
                .on('touchend', '.mw_filter--btn', MagicWall._toggleMobileFilter)
                .on('touchend', MagicWall._toggleMobileSearch)
                .on('click', '.mw_photos--grid-unit', MagicWall._renderPopup)
                .on('click', '.mw_popup--body-pagination-to', MagicWall._renderPopup)
                .on('click', '.mw_popup--close', MagicWall._removePopup)
                .on('scroll', MagicWall._scrollDocumentEvent)
                .on('change', '.mw_filter--sl', MagicWall._getSelectFilter)
                .on('keyup', '#js-search-tag', MagicWall._tagSearch)
                .on('blur', '#js-search-tag', MagicWall._blurSearchTag)
                .on('mousedown', '.js-tag-search-li', MagicWall._clickTagSearchlUnit)
                .on('click', '.pic_tags span', MagicWall._tagPhotoClick)
                .on('click', '.js-pp-course', MagicWall._changeSelectFromPopup)
                .on('click', '.js-pp-cat span', MagicWall._changeSelectFromPopup);
        }
    }

    static _toggleMobileFilter(e) {
        e.target.closest(".mw_filter--wrap").classList.toggle('active');
    }

    static _toggleMobileSearch(e) {
        let self = e.target,
            $self = $(self);

        if ($self.hasClass("mw_filter--search-input"))
            $self.closest(".mw_filter--search").addClass("active");
        else
            document.querySelector(".mw_filter--search").classList.remove("active");
    }

    static _renderPopup(e) {
        $('.container_wrapper').find('.js-mw-popup.isCloned').remove();

        let unit   = e.currentTarget,
            $unit  = $(e.currentTarget),
            $popup = $(".js-mw-popup").clone();

        if ($unit.hasClass('mw_popup--body-pagination-to')) {
            let id = MagicWall._getPhotoIndexFromArray(unit.getAttribute('data-id'));
            let photo = $unit.hasClass('js-to-left') ? MagicWall._getPrevPhoto(id) : MagicWall._getNextPhoto(id);
            unit = MagicWall._renderPhotoUnitNative(photo, false, true);
            if ($unit.hasClass('js-to-left'))
                $popup.addClass('from-left');
            else
                $popup.addClass('from-right');
        }

        $popup.addClass('isCloned');
        $popup.find('.js-pp-img').attr('src', MagicWall._getAttr(unit, '.img img', 'src'));
        MagicWall._getText(unit, '.hover_text .name').length > 0 ? $popup.find('.js-pp-person').text(MagicWall._getText(unit, '.hover_text .name') + ' / ') : $popup.find('.js-pp-person').remove();
        $popup.find('.js-pp-date').text(MagicWall._getText(unit, '.hover_text .date'));
        $popup.find('.js-pp-name').text(MagicWall._getText(unit, '.picture_name'));
        $popup.find('.js-pp-tags').html(MagicWall._getHTML(unit, '.pic_tags'));
        $popup.find('.js-pp-course').text(unit.getAttribute('data-course'));
        $popup.find('.mw_popup--body_main').width($popup.find('.js-pp-img')[0].width);
        $popup.find('.js-pp-img').on("load", function() {
            $popup.find('.mw_popup--body_main').width($popup.find('.js-pp-img')[0].width);
        });
        $popup.find('.mw_popup--body-pagination-to').attr('data-id', unit.getAttribute('data-id'));

        for (let course in courses) {
            if (unit.getAttribute('data-course') === courses[course].ID) {
                $popup.find('.js-pp-course').text(courses[course].UF_NAME).attr('data-id', courses[course].ID);
                break;
            }
        }

        let popCatList = unit.getAttribute('data-cat').split(',');

        for (let i in popCatList) {
            for (let j in cats) {
                if (popCatList[i] == cats[j].ID) {
                    let txt = (parseInt(i)+1) == popCatList.length ? `${cats[j].UF_NAME}` : `${cats[j].UF_NAME},`;
                    $popup.find('.js-pp-cat').append(`<span data-type="category" data-id="${cats[j].ID}">${txt}</span>`);
                }
            }
        }

        if (popCatList.length === 0 || unit.getAttribute('data-cat').length === 0) {
            $popup.find('.js-pp-cat .head_title').remove();
            $popup.find('.mw_popup--body-more_photos').remove();
        } else if ($popup.find('.js-pp-tags >').length !== 0){
            setTimeout(()=> {
                let cityVal = document.querySelector('#js-sl-city').value;
                MagicWall._xhrSend("GET", `${URL}?method=search${unit.getAttribute('data-tags')}&city=${cityVal}`).then((response)=> {
                    MagicWall._initMasonryColumns($popup[0].querySelector('.js-photos-grid'));

                    let list = typeof response === 'string' ? JSON.parse(response).data.photo : response.data.photo;
                    if (notUndefined(list) && list.length > 0) {
                        for (let unit in list) {
                            MagicWall._renderPhotoUnitNative(list[unit], $popup[0].querySelector('.js-photos-grid'));

                            if (parseInt(unit) === 50) {
                                list[unit].last = true;
                                break;
                            }
                        }
                    } else {
                        $popup.find('.mw_popup--body-more_photos').remove();
                    }
                });
            }, 300);
        }

        $('.container_wrapper').append($popup);
        $popup.addClass('active');
        document.querySelector('body').style.overflowY = 'hidden';
    }

    static _removePopup(e) {
        let self = e.currentTarget,
            popup = self.closest(".js-mw-popup");

        popup.classList.add('off');
        setTimeout(() => {
            popup.remove();
        }, 300);
        document.querySelector('body').style.overflowY = 'auto';
    }

    static _getAttr(parent, selector, attr) {
        return parent.querySelector(selector).getAttribute(attr);
    }

    static _getText(parent, selector) {
        return parent.querySelector(selector).textContent;
    }

    static _getHTML(parent, selector) {
        return parent.querySelector(selector).innerHTML;
    }

    static _xhrSend(method, url) {

        return new Promise(function (resolve, reject) {
            let xhr = new XMLHttpRequest();

            xhr.open(method, url);
            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send();
        });
    }

    init() {
        MagicWall._xhrSend('GET', `${URL}?method=filter`).then((res)=>{
            let obj = typeof res === 'string' ? JSON.parse(res) : res;

            tags = obj.data.tags;
            cats = obj.data.category;
            courses = obj.data.course;

            MagicWall._initMasonryColumns(document.querySelector('.js-photos-grid'));

            MagicWall._renderSelectOptions(obj.data);

            let method = 'photo';
            for (const key in obj.data.city) {
                if (obj.data.city.hasOwnProperty(key) && obj.data.city[key].UF_ID_CURRENT)
                    method = `setFilterPhotos&course=&category=&sex=&city=${obj.data.city[key].ID}`;
            }

            MagicWall._xhrSend("GET", `${URL}?method=${method}`).then((response)=> {
                let list = typeof response === 'string' ? JSON.parse(response).data.photo : response.data.photo;
                if (notUndefined(list) && list.length > 0) {
                    photos = list;

                    for (let unit in photos) {
                        MagicWall._renderPhotoUnitNative(photos[unit], document.querySelector('.js-photos-grid'));

                        if (parseInt(unit) === 50) {
                            photos[unit].last = true;
                            photos[0].loaded = true;
                            break;
                        }
                    }
                }
                MagicWall._destroyPreloader();
            });

        }).catch(function (err) {
            console.error(err);
        });
    }

    static _preloadRender() {
        let preloader = document.createElement('div');

        preloader.setAttribute('id', 'pagePreloader');

        document.querySelector('body').appendChild(preloader);
    }

    static _destroyPreloader() {
        document.querySelector('#pagePreloader').remove();
    }

    static _renderSelectOptions(obj) {
        let sls = document.querySelectorAll('.mw_filter--cat select');
        for (let sl = 0; sl < sls.length; sl++) {
            let select = sls[sl],
                list   = obj[select.getAttribute('name')];
            if (notUndefined(list) && list.length > 0) {
                for (let e in list) {
                    let option = document.createElement('option');
                    option.value = list[e].ID;
                    option.innerHTML = list[e].UF_NAME;
                    select.appendChild(option);
                    if (list[e].UF_ID_CURRENT) MagicWall._changeSelectByValue(select, list[e].ID, true);
                }
            }
        }
        MagicWall._initDumbSelectTwo();
    }

    static _renderPhotoUnitNative(obj, to, isShadow) {
        let unit = document.createElement('div');
        let unitTags = obj.UF_TAGS;

        unit.className = 'mw_photos--grid-unit';
        unit.setAttribute('data-cat', obj.UF_CATEGORY.length > 0 ? obj.UF_CATEGORY.join(',') : '');
        unit.setAttribute('data-tags', '&tags[]='  + obj.UF_CATEGORY.length > 0 ? obj.UF_CATEGORY.join('&tags[]=') : '');
        unit.setAttribute('data-course', obj.UF_SEMINAR_ID);
        unit.setAttribute('data-id', obj.ID);

        let img = document.createElement('div');
        img.className = 'img';
        img.innerHTML = `<img src="${obj.UF_FOTO}" alt="${obj.UF_NAME} Studio Estel приклади робіт" title="${obj.UF_NAME} Studio Estel фото робіт"/><div class="hover_text"><span class="name">${obj.UF_USER ? obj.UF_USER : ''}</span><span class="date">${obj.UF_DATE}</span></div>`;
        unit.appendChild(img);

        let tagSection = document.createElement('div');
        tagSection.className = 'tags_section';
        tagSection.innerHTML = `<p class="picture_name">${obj.UF_NAME}</p><div class="pic_tags"></div>`;

        for (let tag in unitTags) {
            for (let gTag in tags) {
                if (unitTags[tag] == tags[gTag].ID) {
                    let span = document.createElement('span');
                    span.setAttribute('data-id', unitTags[tag]);
                    span.innerText = `#${tags[gTag].UF_NAME}`;
                    tagSection.querySelector('.pic_tags').appendChild(span);
                    break;
                }
            }
        }

        unit.appendChild(tagSection);
        if (isShadow) {
            return unit;
        } else {
            if (mobileMatch.matches) {
                to.appendChild(unit);

            } else {
                let column = to.querySelector('.mw_photos--grid-column.last') ? to.querySelector('.mw_photos--grid-column.last') : to.querySelector('.mw_photos--grid-column');

                if (to.querySelector('.mw_photos--grid-column.last')) {
                    column = to.querySelector('.mw_photos--grid-column.last');
                    column.classList.remove('last');

                    if (column.getAttribute('data-number') == 4)
                        column = to.querySelector('.mw_photos--grid-column');
                    else
                        column = to.querySelector(`.mw_photos--grid-column[data-number="${parseInt(column.getAttribute('data-number'))+1}"]`);

                    column.classList.add('last');
                } else {
                    column = to.querySelector('.mw_photos--grid-column');
                    column.classList.add('last');
                }
                column.appendChild(unit);
            }
        }
    }

    static _lazyPhotosLoad(list, selector) {
        let counter = 0;
        let last = !(notUndefined(list[0].loaded) && list[0].loaded),
            length = list.length;

        if (!list[length-1].last) {
            for (let unit in list) {
                if (list[unit].last) {
                    list[unit].last = false;
                    last = true;
                }

                if (last) {
                    MagicWall._renderPhotoUnitNative(list[unit], selector);
                    counter++;
                    if (counter === 50) {
                        list[unit].last = true;
                        break;
                    }
                }
            }
        }
    }

    static _scrollDocumentEvent() {
        let scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
        if (scrollBottom < window.innerHeight)
            MagicWall._lazyPhotosLoad(photos, document.querySelector('.js-photos-grid.mw_photos--grid-main'));
    }

    static _renderSearchResult(rs, tag) {
        document.querySelector('.js-result-block').innerHTML = '';
        let block = document.createElement('div');
        block.className = 'mw_photos--rs';
        block.innerHTML = `<p class="mw_photos--rs-p">Знайдено <span>${rs.length}</span> фотографій</p><p class="mw_photos--rs-tag">« <span>${tag}</span> »</p>`;
        document.querySelector('.js-result-block').appendChild(block);
    }

    static _getSelectFilter(){
        let sls = document.querySelectorAll('.mw_filter--cat select');
        let query = '';
        for (let sl = 0; sl < sls.length; sl++) {
            let select = sls[sl];
            query = query + `&${select.getAttribute('name')}=${select.value}`;
        }
        document.querySelector('.js-result-block').innerHTML = '';
        MagicWall._xhrSend("GET", `${URL}?method=setFilterPhotos${query}`).then((response)=> {
            let list = typeof response === 'string' ? JSON.parse(response).data.photo : response.data.photo;
            document.querySelector('.js-photos-grid').innerHTML = '';
            MagicWall._initMasonryColumns(document.querySelector('.js-photos-grid'));
            if (notUndefined(list) && list.length > 0) {
                photos = list;
                for (let unit in photos) {
                    MagicWall._renderPhotoUnitNative(photos[unit], document.querySelector('.js-photos-grid'));

                    if (parseInt(unit) === 50) {
                        photos[unit].last = true;
                        photos[0].loaded = true;
                        break;
                    }
                }
                if (list.length < 50)
                    list[list.length-1].last = true;
            } else {
                document.querySelector('.js-photos-grid').innerHTML = '<div class="mw_photos--grid-nors">Фотографій не знайдено :(</div>';
            }

        });
    }

    static _tagSearch(e) {
        // up: 38, down: 40, left: 37, right: 39, enter: 13
        let list = document.createElement('ul');

        let active = -1;

        if (document.querySelector('.js-tag-search-ul.mw_filter--search-list')) {
            let ct = document.querySelector('.js-tag-search-ul.mw_filter--search-list');
            if (ct.querySelector('li.active'))
                active = getChildNumber(ct.querySelector('li.active'));
        }


        MagicWall._destroySearchTagList();

        list.className = 'js-tag-search-ul mw_filter--search-list';

        for (let tag in tags) {
            if (tags[tag].UF_NAME.indexOf(e.target.value) !== -1)
                MagicWall._renderSearchListItem(tags[tag], list);
        }
        if (list.querySelectorAll('li').length === 0)
            list.innerHTML = '<li class="mw_filter--search-list-nors">Тегiв не знайдено</li>';

        if (e.target.value.length !== 0) {
            document.querySelector('.mw_filter--search').appendChild(list);

            let items = list.querySelectorAll('li');
            let arrItems = Array.prototype.slice.call(items);
            let selected = active !== -1 ? arrItems[active] : false;

            if (e.keyCode === 40) {
                if (selected) {
                    selected.classList.remove('active');
                    let next = selected.nextSibling ? selected.nextSibling : items[0];
                    next.classList.add('active');
                } else {
                    items[0].classList.add('active');
                }

            } else if (e.keyCode === 38) {
                if (selected) {
                    selected.classList.remove('active');
                    let prev = selected.previousSibling ? selected.previousSibling : items[items.length -1];
                    prev.classList.add('active');
                } else {
                    items[items.length -1].classList.add('active');
                }
            } else if (e.keyCode === 13 && selected) {
                MagicWall._getTagXHR(selected.getAttribute('data-id'), selected.textContent);
            }
        }
    }

    static _renderSearchListItem(obj, to) {
        let item = document.createElement('li');

        item.className = 'js-tag-search-li';
        item.setAttribute('data-id', obj.ID);
        item.innerHTML = obj.UF_NAME;

        to.appendChild(item);
    }

    static _destroySearchTagList() {
        let ct = document.querySelector('.mw_filter--search');

        if (ct.querySelector('.js-tag-search-ul'))
            ct.querySelector('.js-tag-search-ul').remove();
    }

    static _blurSearchTag(e) {
        e.target.value = '';
        setTimeout(()=>{
            MagicWall._destroySearchTagList();
        }, 10);
    }

    static _clickTagSearchlUnit(e) {
        MagicWall._getTagXHR(e.target.getAttribute('data-id'), e.target.textContent);
    }

    static _getTagXHR(tag, tagName) {
        let cityVal = document.querySelector('#js-sl-city').value;
        MagicWall._xhrSend("GET", `${URL}?method=search&tags[]=${tag}&city=${cityVal}`).then((response)=> {
            let list = typeof response === 'string' ? JSON.parse(response).data.photo : response.data.photo;
            document.querySelector('.js-photos-grid').innerHTML = '';
            MagicWall._initMasonryColumns(document.querySelector('.js-photos-grid'));
            if (notUndefined(list) && list.length > 0) {
                photos = list;
                for (let unit in photos) {
                    MagicWall._renderPhotoUnitNative(photos[unit], document.querySelector('.js-photos-grid'));

                    if (parseInt(unit) === 50) {
                        photos[unit].last = true;
                        photos[0].loaded = true;
                        break;
                    }
                }
                if (list.length < 50)
                    list[list.length-1].last = true;
            }
            MagicWall._renderSearchResult(list, tagName);
            document.querySelector('#js-search-tag').value = '';
            MagicWall._destroySearchTagList();
        });
    }

    static _initMasonryColumns(selector) {
        let columns = mobileMatch.matches ? 1 : 4;

        for (let i = 1; i <= columns; i++) {
            let column = document.createElement('div');
            column.className = `mw_photos--grid-column js-mw-grid-column-${i}`;
            column.setAttribute('data-number', i);
            selector.appendChild(column);
        }
    }

    static _initDumbSelectTwo() {
        if(!mobileMatch.matches) {
            $('.mw_filter--sl').select2({
                minimumResultsForSearch: -2,
                width : "copy",
                dropdownAutoWidth: true
            });
        }
    }

    static _getPhotoIndexFromArray(id) {
        for (let i in photos) {
            if (photos[i].ID == id)
                return i;
        }
    }

    static _getNextPhoto(currentIndex) {
        currentIndex = parseInt(currentIndex);
        if (photos.length === currentIndex+1)
            return photos[0];
        else
            return photos[currentIndex+1];
    }

    static _getPrevPhoto(currentIndex) {
        currentIndex = parseInt(currentIndex);
        if (currentIndex === 0)
            return photos[photos.length-1];
        else
            return photos[currentIndex-1];
    }

    static _tagPhotoClick(e) {
        e.stopPropagation();
        let tag = e.currentTarget;

        if ($(tag).parent().hasClass('js-pp-tags'))
            MagicWall._removePopup(e);

        MagicWall._getTagXHR(tag.getAttribute('data-id'), tag.textContent);
    }

    static _changeSelectByValue(sel, val, noTrigger) {
        let opts = sel.options;
        for (let opt, j = 0; opt = opts[j]; j++) {
            if (opt.value == val) {
                sel.selectedIndex = j;
                if (!noTrigger) $(sel).trigger('change');
                break;
            }
        }
    }

    static _changeSelectFromPopup(e) {
        let sel = document.querySelector(`.mw_filter--sl[name="${e.target.getAttribute('data-type')}"]`);
        MagicWall._changeSelectByValue(sel, e.target.getAttribute('data-id'));
        MagicWall._removePopup(e);
    }
}